import React, { useState } from "react";
import logo from "../../assets/images/logo/footer-logo.png";
import footerMadeInIndiaIcon from "../../assets/images/icons/footer-made-in-india-icon.svg";
import footerQualityIcon from "../../assets/images/icons/footer-quality-icon.svg";
import footerSecurePaymentIcon from "../../assets/images/icons/footer-secure-payment-icon.svg";
import footerCustomerIcon from "../../assets/images/icons/footer-customer-icon.svg";
import { Link } from "react-router-dom";
import {
  FacebookOutlined,
  Instagram,
  LinkedIn,
  Pinterest,
  YouTube,
  ArrowForward,
  Language,
  AddOutlined,
  RemoveOutlined
} from "@mui/icons-material";
import ClaimCarousel from "../UI/ClaimCarousel";
import "../../assets/css/footer.css";


const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [openAccordion, setOpenAccordion] = React.useState(0);
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [subStatus, setSubStatus] = useState({ text: "", isError: false });

  const showStatus = (text, isError) => {
    setSubStatus({ text, isError });
    setTimeout(() => {
      setSubStatus({ text: "", isError: false });
    }, 4000);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!newsletterEmail) {
      showStatus("Please enter your email address.", true);
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newsletterEmail)) {
      showStatus("Please enter a valid email address.", true);
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/newsletter/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: newsletterEmail }),
      });
      const data = await res.json();
      if (res.ok) {
        showStatus(data.message || "Successfully subscribed to our newsletter!", false);
        setNewsletterEmail("");
      } else {
        showStatus(data.message || "Subscription failed. Please try again.", true);
      }
    } catch (err) {
      console.error(err);
      showStatus("Something went wrong. Please try again later.", true);
    }
  };

  const handleAccordionClick = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const claims = [
    { icon: footerMadeInIndiaIcon, title: "MADE IN INDIA" },
    { icon: footerQualityIcon, title: "ASSURED QUALITY" },
    { icon: footerSecurePaymentIcon, title: "SECURE PAYMENTS" },
    { icon: footerCustomerIcon, title: "EMPOWERING WEAVERS" },
  ];

  return (
    <>
      <div className="marketingClaims">
        <div className="container">
          <div className="row">
            <ClaimCarousel items={claims} autoRotate={3000} />
          </div>
        </div>
      </div>
      <footer className="footer">
        <div className="footerContainer">
          <div className="row">
            <div className="content-asset footer-logo-wrapper">
              <img src={logo} alt="logo" className="footerLogo" />
            </div>
            <div className="newsletter-container position-relative">
              <label className="newsletter-text">Subscribe to our Newsletter</label>
              <div className="email-section position-relative form-group pt-3 pt-lg-0">
                <input
                  type="email"
                  placeholder="Email Address"
                  className="form-control newsletter-input"
                  value={newsletterEmail}
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleSubscribe(e);
                  }}
                />
                <button type="button" className="newsletter-icon" name="subscribe" onClick={handleSubscribe}>
                  <ArrowForward className="svg-white-arrow-right newsletter-arrow-icon" />
                </button>
              </div>
              {subStatus.text && (
                <span style={{
                  color: subStatus.isError ? "#ff3f6c" : "#2e7d32",
                  fontSize: "1.3rem",
                  marginTop: "0.5rem",
                  display: "block",
                  fontWeight: "500",
                  textAlign: "left"
                }}>
                  {subStatus.text}
                </span>
              )}
            </div>
          </div>
          <div className="line hidden-xs-down"></div>
          <div className="footer-container position-relative observe-me">
            <div className="footer-item">
              <div className="content-asset">
                <div className="item">
                  <button type="button" className="accordionContainer footeraccordion" onClick={() => handleAccordionClick(0)}>
                    <h3 className="heading">Categories</h3>
                    {
                      openAccordion === 0 ? <RemoveOutlined className="accordionIcon" /> : <AddOutlined className="accordionIcon" />
                    }
                  </button>
                  <ul className={`menu-list panel-list${openAccordion === 0 ? " open" : ""}`}>
                    <li>
                      <Link to="/product-category/women-top-wear">Women Top Wear</Link>
                    </li>
                    <li>
                      <Link to="/product-category/handbags">Handbags</Link>
                    </li>
                    <li>
                      <Link to="/product-category/footwear">Footwear</Link>
                    </li>
                    <li>
                      <Link to="/product-category/silver-accessories">Silver Accessories</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-item">
              <div className="content-asset">
                <div className="item">
                  <button type="button" className="accordionContainer footeraccordion" onClick={() => handleAccordionClick(1)}>
                    <h3 className="heading">Quick Links</h3>
                    {
                      openAccordion === 1 ? <RemoveOutlined className="accordionIcon" /> : <AddOutlined className="accordionIcon" />
                    }
                  </button>
                  <ul className={`menu-list panel-list${openAccordion === 1 ? " open" : ""}`}>
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="/faqs">FAQs</Link>
                    </li>
                    <li>
                      <Link to="/blogs">Blogs</Link>
                    </li>
                    <li>
                      <Link to="/store-locator">Store Locator</Link>
                    </li>
                    <li>
                      <Link to="/track-order">
                        Track Order
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-item">
              <div className="content-asset">
                <div className="item">
                  <button type="button" className="accordionContainer footeraccordion" onClick={() => handleAccordionClick(2)}>
                    <h3 className="heading">Our Policies</h3>
                    {
                      openAccordion === 2 ? <RemoveOutlined className="accordionIcon" /> : <AddOutlined className="accordionIcon" />
                    }
                  </button>
                  <ul className={`menu-list panel-list${openAccordion === 2 ? " open" : ""}`}>
                    <li>
                      <Link to="/shipping-details">Shipping Details</Link>
                    </li>
                    <li>
                      <Link to="/exchange-policy">Return, Exchange and Refund Policy</Link>
                    </li>
                    <li>
                      <Link to="/cancellation-refund-policy">Cancellation & Refund Policy</Link>
                    </li>
                    <li>
                      <Link to="/cookie-policy">Cookie Policy</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="footer-item">
              <div className="content-asset">
                <div className="item">
                  <button type="button" className="accordionContainer">
                    <h3 className="heading">Contact Us</h3>
                  </button>
                  <ul className="menu-list">
                    <li>
                      <Link to="" style={{ textDecoration: 'none' }} onClick={(e) => { e.preventDefault(); }}>Pacific Mall, Near, Rajpur Rd, Jakhan, Dehradun, Uttarakhand 248001</Link>
                    </li>
                    <li>
                      <Link to="mailto:care@samriddhiindia.in">Email Id: care@samriddhiindia.in</Link>
                    </li>
                    <li>
                      <Link to="tel:919520782777">Call us at : +91 95207 82777</Link>
                    </li>
                    <li>
                      <Link to="" style={{ textDecoration: 'none' }} onClick={(e) => { e.preventDefault(); }}> 10 am - 7 pm, Monday - Saturday</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="content-asset mt-25">
                <div className="item">
                  <button type="button" className="accordionContainer">
                    <h3 className="heading">KEEP IN TOUCH</h3>
                  </button>
                  <ul className="social-list">
                    <li><a target="_blank" href="https://www.facebook.com/share/14ENqAp9UZd/"><FacebookOutlined /></a></li>
                    <li><a target="_blank" href="https://www.instagram.com/samriddhiindia?igsh=YXk0ejFtZmQxeDI2"><Instagram /></a></li>
                    <li><a target="_blank" href="https://www.linkedin.com/company/samriddhi-india/"><LinkedIn /></a></li>
                    <li><a target="_blank" href="https://youtube.com/@samriddhiindia?si=u9-fNJJOQ_TY3xfv"><YouTube /></a></li>
                    <li><a target="_blank" href="https://pin.it/2aKpFZJC8"><Pinterest /></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="line hidden-xs-down"></div>
          <div className="footer-bottom justify-content-between">
            <div className="footer-first-section w-100">
              <button id="allSitesModal" className="countrySelectorButton">
                <Language className="svg-earth-icon" /> India
              </button>
              <div className="content-asset w-100">
                <div className="footer-delivery-partner">
                  <span className="fed-ex"></span>
                  <span className="blue-dart"></span>
                  <span className="delhivery"></span>
                </div>
              </div>
            </div>

            <div className="content-asset w-100">
              <p className="copy text-nowrap">© {currentYear} Samriddhi India Ltd. All rights reserved.</p>
            </div>

            <div className="content-asset w-100">
              <div className="footer-bottom-desktop-section">
                <div className="footerBottomDesktop">
                  <div className="paymentContainer">
                    <p className="paymentd text-nowrap">100% Secure Payments</p>
                    <span className="payment-method"></span>
                  </div>
                </div>
              </div>

              <div className="footerBottomMobile">
                <p className="paymentm">100% Secure Payments</p>
                <span className="payment-method"></span></div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
